import { env } from './env';

export interface AppConfig {
  apiUrl: string;
  siteName: string;
  tenantCode?: string;
  tenantBaseDomain?: string;
  defaultLocale: string;
  defaultCurrency: string;
}

let appConfig: AppConfig | null = null;

/** Evita `http://host:5000/` + `/api/...` → `//api` (rompe resolve de tenant). */
const normalizeApiUrl = (url: string): string => url.trim().replace(/\/+$/, '');

export const loadAppConfig = async (): Promise<AppConfig> => {
  if (appConfig) {
    return appConfig;
  }

  try {
    const response = await fetch('/config.json');
    if (!response.ok) {
      throw new Error(`config.json no encontrado (${response.status})`);
    }
    const config = await response.json();
    if (!config.apiUrl) {
      throw new Error('config.json debe contener apiUrl');
    }

    appConfig = {
      apiUrl: normalizeApiUrl(config.apiUrl),
      siteName: config.siteName || env.siteName,
      tenantCode: config.tenantCode || undefined,
      tenantBaseDomain: config.tenantBaseDomain || undefined,
      defaultLocale: config.defaultLocale || env.defaultLocale,
      defaultCurrency: config.defaultCurrency || env.defaultCurrency,
    };
    return appConfig;
  } catch (error) {
    console.error('Error al cargar config.json, usando valores por defecto:', error);
    appConfig = {
      apiUrl: normalizeApiUrl(env.apiUrl || 'http://localhost:5000'),
      siteName: env.siteName,
      tenantCode: undefined,
      tenantBaseDomain: undefined,
      defaultLocale: env.defaultLocale,
      defaultCurrency: env.defaultCurrency,
    };
    return appConfig;
  }
};

export const getAppConfig = (): AppConfig | null => appConfig;

export const getApiUrl = (): string => {
  if (appConfig) return appConfig.apiUrl;
  return normalizeApiUrl(env.apiUrl || 'http://localhost:5000');
};

export const getTenantCode = (): string | undefined => {
  if (appConfig?.tenantCode) return appConfig.tenantCode;
  return undefined;
};

export const getSiteName = (): string => {
  if (appConfig) return appConfig.siteName;
  return env.siteName;
};
